import { render, staticRenderFns } from "./ButtonMenu.vue?vue&type=template&id=6cb9da6a&"
import script from "./ButtonMenu.vue?vue&type=script&lang=js&"
export * from "./ButtonMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports